import React, { useEffect, useState } from "react";
import Layout from "layouts";
import CustomerDetailsComponent from "./CustomerDetailsComponent";
import { useParams } from "react-router-dom";
import { getOneUser } from "models/usersModel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function CustomerDetails() {
  const history = useHistory();
  const { customerId = "" } = useParams();
  const [userInfo, setUserInfo] = useState({});
  const loadData = () => {
    getOneUser({
      userid: customerId,
      onFinish: (res, err) => {
        setUserInfo(res?.[0] ?? {});
      },
    });
  };
  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, [customerId]);

  return (
    <Layout
      breadCrumb={[
        { label: "Customers", to: "/customers" },
        { label: history.location.state?.email ?? "", to: "#" },
      ]}
    >
      <CustomerDetailsComponent userInfo={userInfo} />
    </Layout>
  );
}
